import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.mesas;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Cached API wrapper for this namespace/group
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'management_api',
  group: 'mesas',
  defaultTtl: '2m',
  hashLargeSegments: true,
  emitMeta: true,
});

// Function to fetch all mesas
export const getAllMesas = async () => {
  return await retryWithBackoff(() =>
    cachedApi.get('/GetAllMesas')
  );
};

// Function to fetch mesas by company ID
export const getMesasByCompanyId = async (companyId: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetMesasByCompanyId/${companyId}`)
  );
};

// Function to fetch mesas by local ID
export const getMesasByLocalId = async (localId: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetMesasByLocalId/${localId}`)
  );
};

// Function to fetch mesas by salon ID
export const getMesasBySalonId = async (salonId: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetMesasBySalonId/${salonId}`)
  );
};

// Function to fetch a single mesa by ID
export const getMesaById = async (mesaId: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetMesaById/${mesaId}`)
  );
};

// Function to create a mesa
export const createMesa = async (mesaData: any) => {
  const res = await retryWithBackoff(() =>
    api.post('/CreateMesa', mesaData)
  );
  await cachedApi.clear();
  return res;
};

// Function to update a mesa
export const updateMesa = async (mesaId: number, mesaData: any) => {
  const res = await retryWithBackoff(() =>
    api.put(`/UpdateMesa/${mesaId}`, mesaData)
  );
  await cachedApi.clear();
  return res;
};


/**
 * 
 * @param mesaId 
  * @param salonId
  * @param newSalonId
  * 
  * Function to change the salon of a mesa
 * @returns 
 */

export const changeMesaSalon = async (mesaId: number, newSalonId: number) => {
  const res = await retryWithBackoff(() =>
    api.put(`/ChangeMesaSalon/${mesaId}`, { new_salon_id: newSalonId })
  );
  await cachedApi.clear();
  return res;
}

// /ChangeMesaState/<int:mesa_id>

export const changeMesaState = async (mesaId: number) => {
  const res = await retryWithBackoff(() =>
    api.put(`/ChangeMesaState/${mesaId}`)
  );
  await cachedApi.clear();
  return res;
}

// Function to delete a mesa
export const deleteMesa = async (mesaId: number) => {
  const res = await retryWithBackoff(() =>
    api.delete(`/DeleteMesa/${mesaId}`)
  );
  await cachedApi.clear();
  return res;
};


// /MergeMesasByList with a payload like { "mesa_ids": [1, 2, 3] }

export const mergeMesasByList = async (mesa_ids: number[]) => {
  const res = await retryWithBackoff(() =>
    api.post('/MergeMesasByList', { mesa_ids: mesa_ids })
  );
  await cachedApi.clear();
  return res;
};


// /UnMergeMesasByMesaId/<int:mesa_id>

export const unMergeMesasByMesaId = async (mesa_id: number) => {
  const res = await retryWithBackoff(() =>
    api.post(`/UnMergeMesasByMesaId/${mesa_id}`)
  );
  await cachedApi.clear();
  return res;
};

export const unMergeMesasByList = async (mesa_ids: number[]) => {
  const res = await retryWithBackoff(() =>
    api.post('/UnMergeMesasByList', { mesa_ids })
  );
  await cachedApi.clear();
  return res;
};

// /ToggleVirtualByMesaId/<int:mesa_id>

export const toggleVirtualByMesaId = async (mesa_id: number) => {
  const res = await retryWithBackoff(() =>
    api.put(`/ToggleVirtualByMesaId/${mesa_id}`)
  );
  await cachedApi.clear();
  return res;
};